export default {
  all: 'All',
  app_disabled: 'We are updating the contents, they will be available soon',
  autocomplete_placeholder: 'Insert your suburb',
  back_to_list: 'Back To List',
  catalogue_image: "Catalogue's image",
  catalogue_loading: 'We are loading your flyer',
  catalogues: 'Current Catalogues',
  catalogues_in_area: 'Flyers',
  catalogues_loading: 'Loading flyers in your area',
  catalogues_near_you: 'Nearby Flyers',
  catalogues_not_found: 'There are no active offers in this area right now, try another address or come back later',
  close_catalogues: 'Close',
  close_products: 'Close',
  close_stores: 'Close',
  closed: 'Closed',
  characteristics: 'Additional information',
  days_of_week: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  description_missing: 'No description available',
  expired: 'Ended',
  expires: 'Ends',
  find_me: 'Find Me',
  geolocation_error: 'Warning: the localization was not successful',
  geolocation_image: 'Geolocation image',
  geolocation_info: 'In order to show you relevant offers from nearby stores, we will need to know your location. Can you please enter your Suburb or click Find Me below.',
  geolocation_loading: 'We are setting up your position',
  geolocation_missing: 'Share yout location to see the  best deals and stores near you.',
  localize_yourself: 'Localize yourself',
  more_info: 'More Information',
  next: 'Next',
  not_now: 'Not now',
  of: 'Of',
  open: 'Open',
  open_24_hours: 'Open 24h',
  or: 'or',
  other_stores: 'Offers available here:',
  page: 'Page',
  previous: 'Previous',
  price: 'Price',
  products: 'Products',
  products_list: 'Products list',
  read_all: 'Read all',
  sale: 'Sale',
  search_placeholder: 'What are you looking for?',
  stores: 'Stores',
  understand: 'I understand',
  usergeolocation_label: 'Insert your address to find the best deals in stores near you',
  fullscreen: 'Fullscreen',
  fullscreenExit: 'Exit Fullscreen',
  products_find: 'Search a product',
  index: 'Index',
  show_all_pages: 'Show all pages',
  no_nearest_store_at: 'No store nearby',
  nearest_store_at: 'Closest store at {distance}',
  nearby_stores: 'Nearby stores',
  show: 'Show',
  directionVertical: 'Vertical scroll',
  directionHorizontal: 'Horizontal scroll',
  share: 'Share',
  share_with_friends: 'Share with your friends',
  copy_link: 'Copy link',
  sms: 'SMS',
  email: 'email',
  more_stores: 'more stores',
  stores_within: 'Stores within {maxDistance}',
  invalid_offers_disclaimer: 'The offers of this flyer are not valid in stores near you, open another flyer or located in a different area.',
  download_pdf: 'Download PDF',
  available_options: 'Available in {numOptions} options:',
};
